import React, { useEffect, useState } from "react";
// third party
import { Button, Table, Modal } from "antd";
import jsPDF from "jspdf";
import { allUsersApi, breathalizerApi } from "../../api/api";
import LoadingSpiner from "../Common/LoadingSpiner";
import RealTimeMonitoring from "../Monitoring/RealTimeMonitoring";
import "jspdf-autotable";
import "./Table.css";
import PendingUserTable from "./PendingUserTable";
import ReadingsModal from "./BreathalyzerReadings/ReadingsModal";
import AddUserModal from "../Common/modal/AddUserModal/AddUserModal";
import PatientLogModal from "../Common/modal/PatientLogModal/PatientLogModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlag } from "@fortawesome/free-solid-svg-icons";
import UserAssessmentModal from "../AssessmentForm/UserAssessmentModal";

export default function NewUserTable() {
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [token]);

  function convertHeightToInches(heightStr) {
    // Split the string on the space character
    const parts = heightStr?.split(" ");
    if (!parts) {
      return 0;
    } else {
      // Extract feet and inches
      let feet = parts[0] ? parseInt(parts[0].replace("ft", ""), 10) : 0;
      let inches = parts[1] ? parseInt(parts[1].replace("in", ""), 10) : 0;
      // Convert feet to inches and add the inches
      return feet * 12 + inches;
    }
  }

  const fetchData = async () => {
    const weeklyReadingsApi = [
      { _id: "65b042ffbd75e3d549ee24ed", readings: [1, 2, 3, 4, 5, 6, 7] },
      { _id: "65a9e39c63e57cf706ff74e3", readings: [1, 1, 0, 1, 0, 0, 0] },
      { _id: "65ad84573aa33703e7215c3a", readings: [1, 1, 0, 1, 0, 0, 0] },
      { _id: "65b145ad1c34984651ba925c", readings: [2, 1, 5, 1, 6, 0, 0] },
      { _id: "65bbda877386f3ff7b61fd6e", readings: [1, 1, 0, 1, 0, 0, 0] },
      { _id: "65bd316781ccfd57c46485f6", readings: [0, 1, 0, 1, 0, 0, 0] },
      { _id: "65c66f8529468d9c8aa0ee90", readings: [1, 2, 0, 1, 0, 0, 0] },
    ];
    const res = await allUsersApi();

    const weeklyReadingsMap = {};
    weeklyReadingsApi.forEach(({ _id, readings }) => {
      weeklyReadingsMap[_id] = readings;
    });

    if (res) {
      const newData = await Promise.all(
        res.map(async (data) => {
          const { user } = data;
          const { _id, weight, height } = user;
          let bmi = "";
          const heightInInches = convertHeightToInches(height);

          if (!isNaN(weight) && !isNaN(heightInInches) && height !== 0) {
            bmi = ((weight / heightInInches ** 2) * 703).toFixed(2);
          }

          const weeklyReadings = weeklyReadingsMap[_id] || [];
          return {
            ...data,
            user: {
              ...user,
              bmi: bmi,
            },
            weeklyReadings: weeklyReadings,
          };
        })
      );
      setData(newData);
      setFilterData(newData);
      setLoading(false);
    }
  };

  // states
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [filterData, setFilterData] = useState();
  const [keywords, setKeywords] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pdfExportVisible, setPdfExportVisible] = useState(false);
  const [isPatientInfoModalVisible, setIsPatientInfoModalVisible] =
    useState(false);
  const [isAddUserModalVisible, setIsAddUserModalVisible] = useState(false);
  const [pendingData, setPendingData] = useState([]);
  const [timer, setTimer] = useState(0);
  const [timerRunning, setTimerRunning] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [patientLogModal, setPatientLogModal] = useState(false);
  const [assessmentModal, setAssmentModal] = useState(false);

  const showAddUserModal = () => {
    setIsAddUserModalVisible(true);
  };

  const togglePatientInfo = () => {
    setShowPatientInfo(!showPatientInfo);
  };
  const [breathalizerData, setBreathalyzerData] = useState([]);

  useEffect(() => {
    if (selectedRow) {
      getBreathalyzerData(selectedRow._id);
    }
  }, [selectedRow]);

  const getBreathalyzerData = async (id) => {
    try {
      const newRes = await breathalizerApi(id);
      setBreathalyzerData(newRes);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //*TIMER */
  // useEffect(() => {
  //   let interval = null;

  //   if (timerRunning) {
  //     // Set up an interval to increase the timer count every second
  //     interval = setInterval(() => {
  //       setTimer((prevTime) => prevTime + 1);
  //     }, 1000);
  //   } else if (!timerRunning && interval !== null) {
  //     // Clear the interval if the timer is not running
  //     clearInterval(interval);
  //   }

  //   return () => clearInterval(interval); // Cleanup interval on component unmount
  // }, [timerRunning]);

  const handleFullReadings = (record) => {
    setSelectedRow(record);
    setIsModalVisible(true);
    setTimerRunning(true);
    setTimer(0); // Reset timer when modal is opened
  };

  const handleProfile = (record) => {
    setSelectedRow(record);
    setIsPatientInfoModalVisible(true);
  };

  const exportToPdf = () => {
    try {
      // Create a new instance of jsPDF
      const doc = new jsPDF();

      // Add content to the PDF
      doc.text("PDF Export Example", 10, 10);
      // You can add more content here based on your requirements

      // Define the table headers
      const headers = ["Name", "Age", "Total Breathalyzers"];

      // Extract and format data for the table rows
      const tableData = data.map((item) => {
        const { user, totalBreathalyzers } = item;
        return [user.name, user.age, totalBreathalyzers];
      });

      // Add the table to the PDF
      doc.autoTable({
        head: [headers],
        body: tableData,
        startY: 20,
      });

      // Save the PDF or open it in a new tab
      doc.save("exported.pdf");
    } catch (error) {
      console.error("Error exporting to PDF:", error);
      // Handle any error that may occur during PDF export
    }
  };

  const getColor = (value) => {
    if (value <= 0) return "#ebedf0";
    if (value <= 4) return "#9be9a8";
    if (value <= 8) return "#40c463";
    if (value <= 12) return "#30a14e";
    return "#216e39";
  };

  // colums
  const columns = [
    {
      title: "Name",
      dataIndex: ["user", "name"],
      key: "name",
      responsive: ["sm", "md", "lg", "xl"],
      render: (name, record) => (
        <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
          <div
            style={{
              flexBasis: "50%",
              flexGrow: 0,
              flexShrink: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              marginRight: "0px",
            }}
          >
            <h4 className="text-[15px]">{name}</h4>
          </div>
          <button
            style={{
              flexBasis: "30%",
              flexGrow: 0,
              flexShrink: 0,
              padding: "10px",
              backgroundColor: "#F1F1F1",
              borderRadius: "50px",
              fontWeight: "700",
              height: "40px",
            }}
            onClick={() => handleProfile(record)}
          >
            Profile
          </button>
          <div>
            <button
              onClick={() => {
                setAssmentModal(true);
                setSelectedUser(record);
              }}
              className="flagStyles"
            >
              <FontAwesomeIcon icon={faFlag} className="flagStyles" />
            </button>
          </div>
        </div>
      ),
    },
    {
      title: "AuditC",
      dataIndex: ["user", "auditC"],
      key: "auditCauditC",
      render: (title) => <h4 className="text-[15px]">{title}</h4>,
      responsive: ["sm"],
    },
    {
      title: "#/16",
      dataIndex: "uniqueDaysWithBreathalyzerCount",
      key: "totalBreathalyzers",
      sorter: (a, b) =>
        parseInt(a.totalBreathalyzers) - parseInt(b.totalBreathalyzers),
      sortOrder:
        sortedInfo.columnKey === "totalBreathalyzers" ? sortedInfo.order : null,
      render: (text, record) => {
        // Calculate the fraction
        const fraction = `${text}/16`;

        return (
          <div>
            <h4 className="text-[15px]">{fraction}</h4>
          </div>
        );
      },
    },
    {
      title: "Action",
      key: "report",
      render: (text, record) => (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <button
            className="bg-[#6434FFB8] w-[94px] h-[32px] text-white rounded-full text-[12px] mr-4"
            onClick={() => {
              setPatientLogModal(true);
              setSelectedUser(record);
            }}
          >
            Patient Log
          </button>
          <button
            className="w-[94px] h-[32px] bg-[#F1F1F1]  rounded-full text-[12px]"
            onClick={() => handleFullReadings(record)}
          >
            Full Readings
          </button>
        </div>
      ),
    },
  ];
  // onchange function
  const onChange = (pagination, filters, sorter, extra) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setTimerRunning(false);
  };

  const renderUserInformationModal = () => {
    if (!selectedRow || !selectedRow.user) {
      return null;
    }
    return (
      <Modal
        title="Patient Information"
        open={isPatientInfoModalVisible}
        onCancel={() => setIsPatientInfoModalVisible(false)}
        footer={null}
      >
        <p>
          <strong>Name:</strong> {selectedRow.user.name}
        </p>
        <p>
          <strong>Age:</strong> {selectedRow.user.ages}
        </p>
        <p>
          <strong>BMI:</strong> {selectedRow.user.bmi}
        </p>
        <p>
          <strong>Insurance:</strong> {selectedRow.user.insurance}
        </p>
        <p>
          <strong>Total Breathalyzer Recordings:</strong>{" "}
          {selectedRow.totalBreathalyzers}
        </p>
        <p>
          <strong>Sessions:</strong> {selectedRow.user.numSessions}
        </p>
        <p>
          <strong>Total Visits:</strong> {selectedRow.user.totalVisit}
        </p>
        <p>
          <strong>Provider:</strong> {selectedRow.user.provider}
        </p>
        <p>
          <strong>Facility:</strong> {selectedRow.user.facility}
        </p>
        <p>
          <strong>Status:</strong> {selectedRow.user.status}
        </p>
      </Modal>
    );
  };

  const renderModal = () => {
    //if (selectedRow) {

    if (selectedRow) {
      return (
        <>
          <Modal
            open={isModalVisible}
            onCancel={() => closeModal()}
            width={1200}
            footer={null}
          >
            <ReadingsModal
              user={selectedRow.user._id}
              patientInfo={selectedRow.user}
              breathalyzer={selectedRow.totalBreathalyzers}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {/* <p>Timer: {timer} seconds</p>  */}
            </div>
          </Modal>
        </>
      );
    }
    return null;
  };

  if (loading) {
    return <LoadingSpiner loading={loading} />;
  } else {
    return (
      <div>
        <Button style={{ width: "30%" }} onClick={showAddUserModal}>
          Add User
        </Button>
        <div
          style={{ position: "fixed", top: 0, right: 0, padding: "10px" }}
        ></div>
        <div className="container mb-10">
          <div className="flex items-center justify-between">
            <div>
              {selectedRowKeys.length !== 0 && (
                <div className="flex items-center">
                  <p className="text-[10px] mr-2">
                    {selectedRowKeys.length} select{" "}
                  </p>
                </div>
              )}
            </div>
            <div className="mb-[15px] flex"></div>
          </div>

          <PendingUserTable userData={pendingData} />

          <div style={{ padding: 20, float: "left" }}></div>
          <h2 className="table-title">User Details</h2>
          {data && (
            <Table
              columns={columns}
              dataSource={data}
              // onRow={(record) => ({
              //   onClick: () => handleRowClick(record), // Handle row click
              // })}
              pagination={{
                pageSize: pageSize,
                current: page,
                onChange: (page, pageSize) => {
                  setPage(page);
                  setPageSize(pageSize);
                },
              }}
              onChange={onChange}
              rowKey={(record) => record._id}
            />
          )}
          <div className="mb-[15px] flex"></div>
          <Button
            style={{ float: "left", margin: "20px" }}
            onClick={() => exportToPdf(selectedRow)}
          >
            Export as PDF
          </Button>
        </div>
        {renderModal()}
        {isAddUserModalVisible && (
          <AddUserModal
            isVisible={isAddUserModalVisible}
            setIsVisible={setIsAddUserModalVisible}
            pendingData={pendingData}
            setPendingData={setPendingData}
          />
        )}
        {patientLogModal && (
          <PatientLogModal
            isVisible={patientLogModal}
            setIsVisible={setPatientLogModal}
            selectedUser={selectedUser}
          />
        )}
        {patientLogModal && (
          <PatientLogModal
            isVisible={patientLogModal}
            setIsVisible={setPatientLogModal}
            selectedUser={selectedUser}
          />
        )}
        {assessmentModal && (
          <UserAssessmentModal
            isVisible={assessmentModal}
            setIsVisible={setAssmentModal}
            selectedUser={selectedUser}
          />
        )}
        {renderUserInformationModal()}
      </div>
    );
  }
}
